import { useState, useCallback, useContext } from 'react';

import BackendContext from '@shared/data-access-frontend/contexts/backend-context';

type HotelReviewsHelpfulParams = {
  partner: string;
  locale: string;
  hotelId: string;
  partnerReviewId: string;
};

const useHotelReviewsHelpful = (params: HotelReviewsHelpfulParams) => {
  const backendGateway = useContext(BackendContext);

  const [isHelpful, setIsHelpful] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const toggleHelpful = useCallback(() => {
    const newIsHelpful = !isHelpful;
    setIsHelpful(newIsHelpful);

    setIsAnimating(false);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        setIsAnimating(true);
      });
    });

    backendGateway.reviewHelpful({
      ...params,
      isHelpful: newIsHelpful,
    });
  }, [backendGateway, params, isHelpful]);

  return {
    isHelpful,
    isAnimating,
    toggleHelpful,
  };
};

export default useHotelReviewsHelpful;
